module.exports = __webpack_public_path__ + "static/img/touxiang@3x.a4a43da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/touxiang@3x.png
// module id = IipA
// module chunks = 1